<template>
    <div
        class="terpenes lot-result-card"
        :class="cssPrefix + '__results__col__terpene-values'"
        v-if="itemCount > 0"
    >
        <div
            class="flex px-4 py-2 items-center justify-between"
            :class="[
        cssPrefix + '__results__col__terpene-values__title-row',
      ]"
        >
            <h4>Terpenes</h4>
            <small>Parts per Million (ppm)</small>
        </div>
        <div
            class="flex overflow-hidden relative w-full"
            :class="cssPrefix + '__results__col__terpene-values__container'"
        >
            <Striping :count="itemCount"/>
            <div
                class="w-full grid grid-cols-2"
                :class="[
          cssPrefix + '__results__col__terpene-values__container__row',
        ]"
                :style="{ height: chartHeight, zIndex: 2 }"
            >
                <div
                    class="flex flex-col w-full pl-4 pr-1"
                    :class="cssPrefix + '__results__col__terpene-values__container__row__labels'"
                    :style="{ height: chartHeight }"
                >
                    <div
                        class="flex justify-between"
                        :class="cssPrefix + '__results__col__terpene-values__container__row__labels__group'"
                        v-if="showKey('scdMyrcene')"
                    >
                        <small
                            class="uppercase py-1 cursor-default"
                            :class="
                cssPrefix + '__results__col__terpene-values__container__row__labels__group__title'
              "
                        >
                            Myrcene
                        </small>
                        <small class="py-1" v-if="isSingle"> {{ lotStore.lots[0].brewingValues?.scdMyrcene }}</small>
                    </div>
                    <div
                        class="flex justify-between"
                        :class="cssPrefix + '__results__col__terpene-values__container__row__labels__group'"
                        v-if="showKey('scdBetaPinene')"
                    >
                        <small
                            class="uppercase py-1 cursor-default"
                            :class="
                cssPrefix + '__results__col__terpene-values__container__row__labels__group__title'
              "
                        >
                            Beta Pinene
                        </small>
                        <small class="py-1" v-if="isSingle && lotStore.lots[0].brewingValues?.scdBetaPinene">
                            {{ lotStore.lots[0].brewingValues?.scdBetaPinene }}%
                        </small>
                    </div>
                    <div
                        class="flex justify-between"
                        :class="cssPrefix + '__results__col__terpene-values__container__row__labels__group'"
                        v-if="showKey('scdLimonene')"
                    >
                        <small
                            class="uppercase py-1 cursor-default"
                            :class="
                cssPrefix + '__results__col__terpene-values__container__row__labels__group__title'
              "
                        >Limonene</small
                        >
                        <small class="py-1" v-if="isSingle && lotStore.lots[0].brewingValues?.scdLimonene"
                        >{{ lotStore.lots[0].brewingValues?.scdLimonene }}%</small
                        >
                    </div>
                    <div
                        v-if="showKey('scdTransCaryophyllene')"
                        class="brewing-values__container__row__labels__group flex justify-between"
                    >
                        <small
                            class="brewing-values__container__row__labels__group__title uppercase py-1 cursor-default"
                        >
                            Trans Caryophyllene
                        </small>
                        <small class="py-1" v-if="isSingle && lotStore.lots[0].brewingValues?.scdTransCaryophyllene">
                            {{ lotStore.lots[0].brewingValues?.scdTransCaryophyllene }}%
                        </small>
                    </div>
                    <div
                        class="flex justify-between"
                        :class="cssPrefix + '__results__col__terpene-values__container__row__labels__group'"
                        v-if="showKey('scdHumulene')"
                    >
                        <small
                            class="uppercase py-1 cursor-default"
                            :class="
                cssPrefix + '__results__col__terpene-values__container__row__labels__group__title'
              "
                        >Humulene</small
                        >
                        <small class="py-1" v-if="isSingle && lotStore.lots[0].brewingValues?.scdHumulene"
                        >{{ lotStore.lots[0].brewingValues?.scdHumulene }}%</small
                        >
                    </div>
                </div>
                <terpene-values :style="{ height: chartHeight }"/>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import {computed} from 'vue'
import TerpeneValues from '@/components/Charts/TerpeneValuesChart.vue'
import useLotStore from '@/stores/LotStore'
import {terpeneComponentsChartItemCount as itemCount} from '@/composables/filterSettings'
import Striping from '@/components/Charts/Striping.vue'

const showKey = (keyName: string) => true

const lotStore = useLotStore()

const isSingle = computed(() => {
    return lotStore.lots.length === 1
})
const cssPrefix = computed(() => {
    if (isSingle.value) {
        return 'lot-lookup-single'
    }
    return 'lot-lookup-multi'
})

const chartHeight = computed(() => {
    return (itemCount.value * 1.5).toString() + 'rem'
})
</script>

<style lang="scss">
.terpenes {
    .lot-lookup-single__results__col__terpene-values,
    .lot-lookup-multi__results__col__terpene-values {

        &__container__row {
            z-index: 1;

            &__labels {
                border-right: 1px solid var(--ych-grey-200);
                overflow: hidden;

                &__group {
                    align-items: center;
                    height: 1.5rem;
                    gap: 0.5rem;

                    &__title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
</style>
